/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionPricingQuery from '../graphql/queries/GetSouscriptionPricingQuery.js';

const useGetSouscriptionPricingQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionPricingQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionPricing: R.omit(['__typename'], data?.getSouscriptionPricing_souscription_pricing || {})
  };
};

export default useGetSouscriptionPricingQuery;
